import React from "react";

const Referidos = () => {
  const referrals = [
    {
      id: "HVLorenzoPi",
      name: "Lorenzo Pérez",
      email: "lorenzo.perez@example.com",
      joinedDate: "2024-11-20",
      status: "Activo",
    },
    {
      id: "HVJuanaSm",
      name: "Juana Smith",
      email: "juana.smith@example.com",
      joinedDate: "2024-10-15",
      status: "Inactivo",
    },
    {
      id: "HVCarlosMm",
      name: "Carlos Mendoza",
      email: "carlos.mendoza@example.com",
      joinedDate: "2024-09-10",
      status: "Activo",
    },
  ];

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Tus Referidos</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {referrals.map((referral) => (
          <div
            key={referral.id}
            className="p-4 bg-white rounded-lg shadow border border-gray-200 relative"
          >
            <div className="absolute top-2 right-2">
              {referral.status === "Activo" ? (
                <span className="bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded-full">
                  Activo
                </span>
              ) : (
                <span className="bg-red-100 text-red-700 text-xs font-bold px-2 py-1 rounded-full">
                  Inactivo
                </span>
              )}
            </div>
            <h3 className="text-lg font-bold mb-2">{referral.name}</h3>
            <p className="text-gray-600 text-sm mb-2">Email: {referral.email}</p>
            <p className="text-gray-500 text-sm mb-2">Unido: {referral.joinedDate}</p>
            <p className="text-gray-700 font-semibold">Código: {referral.id}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Referidos;
